import { BlocksUtilityNav } from 'blocks-nextjs/blocks-web-components/components/utility-nav/utility-nav';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

/**
 * @deprecated - This component `CatUtilityNav` has been deprecated and the updated version will be available with name `CatUtilityNavLabs`. New component will be found under labs folder from Minor Release 3.10.0, `CatUtilityNav` will be removed in 5.0 major release.
 */

export const CatUtilityNav = createComponent({ react: React, tagName: 'cat-utility-nav', elementClass: BlocksUtilityNav });
